import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MarkdownViewerWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
}));

export const MarkdownContent = styled(Box)(({ theme }) => ({
  maxWidth: '900px',
  margin: '0 auto',
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  lineHeight: '1.6',
  color: theme.palette.text.primary,
  
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    lineHeight: 1.25,
  },
  
  '& h1': {
    fontSize: '2em',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  
  '& h2': {
    fontSize: '1.5em',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  
  '& h3': {
    fontSize: '1.25em',
  },
  
  '& p': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  
  '& ul, & ol': {
    paddingLeft: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  
  '& li': {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  
  '& code': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    padding: '2px 6px',
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.9em',
    fontFamily: 'Monaco, Courier, monospace',
  },
  
  '& pre': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    overflow: 'auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    
    '& code': {
      backgroundColor: 'transparent',
      padding: 0,
    },
  },
  
  '& blockquote': {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing(2),
    marginLeft: 0,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  
  '& table': {
    borderCollapse: 'collapse',
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  
  '& th, & td': {
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5),
    textAlign: 'left',
  },
  
  '& th': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
    fontWeight: 600,
  },
  
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  
  '& hr': {
    border: 'none',
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export const LoaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  minHeight: '200px',
});

export const ErrorWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  minHeight: '200px',
  color: theme.palette.error.main,
}));

